import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { useGetCommonStore } from '@/store';

import {
  type ScSkeletonProps,
  ScStaticModalSkeleton,
  ScStaticModalSkeletonMobile,
} from './styled';

interface SkeletonProps extends ScSkeletonProps {}

export const Skeleton: FC<SkeletonProps> = (props) => {
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return isMobileDevice ? (
    <StaticModalSkeletonMobile />
  ) : (
    <StaticModalSkeleton {...props} />
  );
};

export const StaticModalSkeleton: FC<SkeletonProps> = (props) => (
  <ScStaticModalSkeleton {...props}>
    <ContentLoader
      backgroundColor="#ccc"
      foregroundColor="#ecebeb"
      speed={2}
      viewBox={
        props.width ? `0 0 ${props.width} ${props.width + 120}` : '0 0 480 500'
      }
    >
      <rect height="30" rx="5" ry="5" width="60%" x="0" y="15" />
      <rect height="50" rx="4" ry="4" width="190" x="0" y="80" />
      <rect height="15" rx="4" ry="4" width="80%" x="15" y="210" />
      <rect height="15" rx="4" ry="4" width="70%" x="15" y="250" />
    </ContentLoader>
  </ScStaticModalSkeleton>
);

export const StaticModalSkeletonMobile = () => (
  <ScStaticModalSkeletonMobile>
    <ContentLoader
      foregroundColor="#ecebeb"
      height="100%"
      speed={2}
      width="100%"
    >
      <rect height="30" rx="5" ry="5" width="60%" x="15" y="15" />
      <rect height="50" rx="4" ry="4" width="190" x="15" y="80" />
      <rect height="15" rx="4" ry="4" width="80%" x="15" y="210" />
      <rect height="15" rx="4" ry="4" width="70%" x="15" y="250" />
    </ContentLoader>
  </ScStaticModalSkeletonMobile>
);
